import { API_URL } from "@/misc/constants";
import { get, post, put, remove } from "./index";
import { mastersCache } from "@/misc/httpCache";
import { analyticsAction } from "@/utils/analytics";
import type {
  tChangeMasterServicePositionArgs,
  tCreateMasterServiceArgs,
  tGetMasterServiceTitleSuggestions,
  tMasterServiceTitle,
  tMasterService,
  tUpdateMasterServiceArgs,
} from "@/types";

const BASE_URL = `${API_URL}/service`;
const getTitleCompletion = (params: tGetMasterServiceTitleSuggestions) => {
  return get<tMasterServiceTitle[]>(`${BASE_URL}/title/autocomplete`, {
    params,
  });
};
const getTitleBySlug = (slug: string) => {
  return get<tMasterServiceTitle>(`${BASE_URL}/title/slug/${slug}`);
};
const findById = (id: string) => {
  return get<tMasterService>(`${BASE_URL}/${id}`, { cache: false });
};
const updateById = async (id: string, payload: tUpdateMasterServiceArgs) => {
  const res = await post<tMasterService>(`${BASE_URL}/${id}`, payload);
  if (mastersCache) {
    mastersCache.reset();
  }
  return res;
};
const deleteById = async (id: string) => {
  const res = await remove<tMasterService>(`${BASE_URL}/${id}`);
  if (mastersCache) {
    mastersCache.reset();
  }
  return res;
};
const getUnits = (params: any) => {
  return get(`${BASE_URL}/unit`, { params });
};
const create = async (payload: tCreateMasterServiceArgs) => {
  const res = await put<tMasterService>(BASE_URL, payload);
  analyticsAction({ category: "Service", action: "Add" });
  if (mastersCache) {
    mastersCache.reset();
  }
  return res;
};
const changePosition = async (
  id: string,
  payload: tChangeMasterServicePositionArgs,
) => {
  const res = await post<{ services_ids: string[]; master_id: string }>(
    `${BASE_URL}/${id}/changePosition`,
    payload,
  );
  if (mastersCache) {
    mastersCache.reset();
  }
  return res;
};

export const ServiceAPI = {
  create,
  findById,
  getUnits,
  getTitleCompletion,
  getTitleBySlug,
  deleteById,
  updateById,
  changePosition,
};
